import { parseAbsoluteToLocal } from "@internationalized/date";
import { Controller, useFormContext } from "react-hook-form";

import {
  dateTimeToDateValue,
  dateValueToDate,
  NcDateField,
  NcDateFieldProps,
} from "./nc-date-field";

export interface NcFormDateFieldProps
  extends Omit<
    NcDateFieldProps,
    | "name"
    | "validate"
    | "onBlur"
    | "onChange"
    | "value"
    | "validationBehavior"
    | "minValue"
    | "maxValue"
  > {
  name: string; // Was optional in NcDateFieldProps and is now required
  minValue?: Date; // Using native Date type instead of DateValue
  maxValue?: Date; // Using native Date type instead of DateValue
  onChange?: (date: Date | undefined) => void; // Using native Date type instead of DateValue
}

export const NcFormDateField = ({
  name,
  minValue,
  maxValue,
  onChange,
  ...props
}: NcFormDateFieldProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { name, value, onChange: formOnChange, onBlur, ref },
        fieldState: { invalid, error },
      }) => (
        <NcDateField
          name={name}
          granularity="day"
          minValue={minValue ? parseAbsoluteToLocal(minValue.toISOString()) : undefined}
          maxValue={maxValue ? parseAbsoluteToLocal(maxValue.toISOString()) : undefined}
          value={dateTimeToDateValue(value)}
          onChange={date => {
            const parsedDate = dateValueToDate(date || undefined);
            onChange?.(parsedDate);
            formOnChange(parsedDate);
          }}
          onBlur={onBlur}
          validationBehavior="aria"
          isInvalid={invalid}
          error={error}
          ref={ref}
          {...props}
        />
      )}
    />
  );
};
